export class groupRolGU {
    public id: number;
    public nombre: String;
    public status: boolean;
}